import { Controller } from "@hotwired/stimulus"

// Updates a character counter when the user types in the title field.
export default class TitleCounterController extends Controller {
  static targets = ["input", "counter"]

  connect() {
    this.updateFromInput()
  }

  // Called when input/keyup bubbles from the title field; use event.target so we always read the right value.
  updateFromEvent(event) {
    const el = event?.target
    if (!el || !this.hasCounterTarget) return
    if (!this.hasInputTarget || el !== this.inputTarget) return
    this.counterTarget.textContent = (el.value || "").length
  }

  updateFromInput() {
    if (!this.hasInputTarget || !this.hasCounterTarget) return
    this.counterTarget.textContent = (this.inputTarget.value || "").length
  }
}
